(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["purenova-pdp-hero"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   Purenova PDP Hero — Timer + Bullet Accordion
   ============================================================ */
(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('.pn-section');

    sections.forEach(function(section) {
      var sectionId = section.dataset.sectionId;
      var mode = section.dataset.timerMode || 'daily';
      var endDateStr = section.dataset.timerEnd || '';
      var showInCta = section.dataset.timerInCta === 'true';

      /* --- Countdown Timer --- */
      var targets = [];

      var barTimer = section.querySelector('#countdown-' + sectionId);
      if (barTimer) targets.push(barTimer);

      if (showInCta) {
        var ctaTimer = section.querySelector('#cta-timer-' + sectionId);
        if (ctaTimer) targets.push(ctaTimer);
      }

      var stickyTimer = section.querySelector('#sticky-timer-' + sectionId);
      if (stickyTimer) targets.push(stickyTimer);

      if (targets.length > 0) {
        function getEndTime() {
          if (mode === 'fixed' && endDateStr) {
            return new Date(endDateStr).getTime();
          }
          var now = new Date();
          var midnight = new Date(now);
          midnight.setHours(24, 0, 0, 0);
          return midnight.getTime();
        }

        function updateTimers() {
          var now = Date.now();
          var end = getEndTime();
          var diff = end - now;

          if (diff <= 0) {
            if (mode === 'fixed') {
              targets.forEach(function(el) { el.style.display = 'none'; });
              return;
            }
            diff = 0;
          }

          var totalSeconds = Math.floor(diff / 1000);
          var hours = Math.floor(totalSeconds / 3600);
          var minutes = Math.floor((totalSeconds % 3600) / 60);
          var seconds = totalSeconds % 60;

          var hh = hours < 10 ? '0' + hours : '' + hours;
          var mm = minutes < 10 ? '0' + minutes : '' + minutes;
          var ss = seconds < 10 ? '0' + seconds : '' + seconds;

          targets.forEach(function(el) {
            var hEl = el.querySelector('[data-hours]');
            var mEl = el.querySelector('[data-minutes]');
            var sEl = el.querySelector('[data-seconds]');
            if (hEl) hEl.textContent = hh;
            if (mEl) mEl.textContent = mm;
            if (sEl) sEl.textContent = ss;
          });
        }

        updateTimers();
        setInterval(updateTimers, 1000);
      }

      /* --- Bullet Accordion --- */
      var toggles = section.querySelectorAll('[data-pn-toggle]');
      toggles.forEach(function(row) {
        function toggle() {
          var bullet = row.closest('.pn-bullet');
          var isOpen = bullet.classList.contains('is-open');

          /* Close all others in this section */
          section.querySelectorAll('.pn-bullet.is-open').forEach(function(b) {
            b.classList.remove('is-open');
            var r = b.querySelector('[data-pn-toggle]');
            if (r) r.setAttribute('aria-expanded', 'false');
            var reveal = b.querySelector('.pn-bullet__reveal');
            if (reveal) reveal.setAttribute('aria-hidden', 'true');
          });

          /* Toggle current */
          if (!isOpen) {
            bullet.classList.add('is-open');
            row.setAttribute('aria-expanded', 'true');
            var reveal = bullet.querySelector('.pn-bullet__reveal');
            if (reveal) reveal.setAttribute('aria-hidden', 'false');
          }
        }

        row.addEventListener('click', toggle);
        row.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            toggle();
          }
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
